'use client';

import Image from 'next/image';
import type {FC} from 'react';

interface FavoritesToggleProps {
  isActive?: boolean;
  onChange?: (isActive: boolean) => void;
  className?: string;
}

export const FavoritesToggle: FC<FavoritesToggleProps> = ({isActive = false, onChange, className = ''}) => {
  const handleClick = () => {
    onChange?.(!isActive);
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className={`relative flex items-center w-[185px] h-12 rounded-[35px] border border-[#eeeeee] bg-transparent hover:bg-white/5 ${className}`}
    >
      <div className="flex items-center justify-between w-full pl-2 pr-4 py-2">
        <div className="flex items-center gap-2.5">
          <div className="w-8 h-8 relative">
            <Image
              src="/icons/heartExp.svg"
              alt=""
              fill
              sizes="32px"
              className={`transition-colors duration-200 ${isActive ? 'text-[#ff110f]' : 'text-white'} [&_path]:fill-current`}
            />
          </div>
          <span className="text-white text-base tracking-[-0.16px] leading-6 font-normal">Favorites</span>
        </div>
        <div className="grid grid-cols-[max-content] grid-rows-[max-content] place-items-start">
          <div
            className={`relative w-[34px] h-5 ${
              isActive ? 'bg-[#ff110f]' : 'bg-[#cccccc]'
            } rounded-[43px] transition-colors duration-200`}
          >
            <div
              className={`absolute top-[2px] w-4 h-4 bg-white rounded-[40px] shadow-[0_1px_2px_0_rgba(0,0,0,0.2)] transition-all duration-200 ease-in-out ${
                isActive ? 'left-[15px]' : 'left-[2px]'
              }`}
            />
          </div>
        </div>
      </div>
    </button>
  );
};
